<mat-card class="decoration-card">
    <mat-card-content>

        <mat-toolbar *ngIf="!isReadonly">
            <span class="example-spacer"></span>

            <button mat-icon-button class="crud_action" matTooltip="add a recommendation" (click)="createRecommendation()" *ngIf="!isReadonly">
                <mat-icon>plus_one</mat-icon>
            </button>
        </mat-toolbar>

        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
            <!--- Note that these columns can be defined in any order.
              The actual rendered columns are set as a property on the row definition" -->

            <!-- sn Column -->
            <ng-container matColumnDef="sn">
                <th mat-header-cell *matHeaderCellDef> SN </th>
                <td mat-cell *matCellDef="let element"> {{element.sn}} </td>
            </ng-container>

            <!-- description Column -->
            <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef> Description </th>
                <td mat-cell *matCellDef="let element"> {{element.description}} </td>
            </ng-container>

            <!-- type Column -->
            <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef> Type </th>
                <td mat-cell *matCellDef="let element"> {{element.type_text}} </td>
            </ng-container>

            <!-- closed Column -->
            <ng-container matColumnDef="closed">
                <th mat-header-cell *matHeaderCellDef> Closed </th>
                <td mat-cell *matCellDef="let element"> {{element.closed_text}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row (click)="selectRecommendation(row)" *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

    </mat-card-content>
</mat-card>